export default __webpack_public_path__ + "static/media/logo_impuls.e5cb6cdc.png";